import React, { useEffect, useState } from 'react';
import CreateServiceRequest from './CreateServiceRequest';
import { useParams } from 'react-router';
import { Grid, Typography } from '@material-ui/core';
import { apiGet } from '../../api/client';

export default function UpdateServiceRequest() {
  let { request } = useParams();
  const [serviceRequestbyId, setServiceRequestbyId] = useState();
  useEffect(() => {
    apiGet(`/requests/${request}`)
      .then(({ data }) => setServiceRequestbyId(data))
      .catch((err) => {
        alert(`ERR: ${err.message || err}`);
      });
  }, [request]);

  return serviceRequestbyId ? (
    <CreateServiceRequest
      update={true}
      serviceRequestId={request}
      title={serviceRequestbyId.title}
      description={serviceRequestbyId.description}
      serviceabletime={serviceRequestbyId.serviceableTime}
      attachments={serviceRequestbyId.attachments}
      serviceid={serviceRequestbyId.serviceId}
      deliverymode={serviceRequestbyId.receivingMethod}
    />
  ) : (
    <Grid container justify="center">
      <Typography variant="h3">Loading...!</Typography>
    </Grid>
  );
}
